import Keycloak from 'keycloak-js';
import Cookies from 'universal-cookie';

const SPOC_COOKIE_NAME = 'spoc';
const TUTORIAL_COOKIE_NAME = 'tutorial';
let cookie: Cookies | null = null; // FIXME should be initialized properly
export function logout(kc: Keycloak) {
    deleteTutorialCookie();
    deleteSpocCookie();
    deleteLocalStorageToken();
    kc.logout({ redirectUri: window.location.origin }).then();
}

export function loadSpocCookie() {
    return cookie?.get(SPOC_COOKIE_NAME);
}

export function initCookie() {
    if (!cookie) {
        cookie = new Cookies();
    }
}

function deleteSpocCookie() {
    cookie?.remove(SPOC_COOKIE_NAME, { path: '/' });
}

function deleteLocalStorageToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
}

export type TutorialCookie = {
    readonly showIntroVideo: boolean;
    readonly showReserveVideo: boolean;
};

export function loadTutorialCookie(): TutorialCookie {
    const cookieValue = cookie?.get(TUTORIAL_COOKIE_NAME);

    if (typeof cookieValue === 'object') {
        return {
            showIntroVideo: Boolean(cookieValue.showIntroVideo),
            showReserveVideo: Boolean(cookieValue.showReserveVideo)
        };
    }

    return { showIntroVideo: true, showReserveVideo: true };
}

export function saveTutorialCookie(tutorialCookie: TutorialCookie) {
    cookie?.set(TUTORIAL_COOKIE_NAME, tutorialCookie, { path: '/' });
}

export function deleteTutorialCookie() {
    cookie?.remove(TUTORIAL_COOKIE_NAME, { path: '/' });
}

export function isCatalogueManagementAdmin(kc: Keycloak) {
    return kc.hasRealmRole('catalogue_management_admin');
}

export function isAllowedToPublishToNetwork(kc: Keycloak) {
    return kc.hasRealmRole('lc_publish_for_network');
}

export function hasLCManageRole(kc: Keycloak) {
    return kc.hasRealmRole('lc_manage');
}

export function isImpersonationAllowed(keycloak: Keycloak) {
    return (
        keycloak.hasResourceRole('impersonation', 'realm-management') &&
        keycloak.hasResourceRole('view-users', 'realm-management')
    );
}
